import * as THREE from 'three';
import { Raycaster, Intersection, Matrix4 } from 'three';
import { FikoThreeJsComponent } from '../fiko-three-js.component';
import { FikoArrowYardimci } from './FikoArrowYardimci';
import { FikoGrup } from './FikoGrup';
import { FikoSahne } from './FikoSahne';
// import { FikoApt } from './FikoThreeCam/FikoApt';
import { FikoVektor3D } from './FikoVektor3d';
import { FikoEksenComponent } from './fiko-eksen/fiko-eksen.component';

export class FikoEksen extends FikoGrup {
    override type: any = "FikoEksen";
    /** */
    loader: THREE.FileLoader = new THREE.FileLoader();
    /** */
    odakAktif = false;
    secili = false;
    secilebilir = true;
    enUstte = true;
    sabitBoyut: boolean = true;

    // 🚀 PERFORMANS: Event handler referansı - dispose için gerekli
    private _kontrolDegistiHandler: ((event: any) => void) | null = null;

    renkler = {
        merkez: 0x000000,
        x: 0x00a3ff,
        y: 0x05ab44,
        z: 0xffff00,
    }

    sagMenu = [
        {
            simgeYazi: "👁‍🗨",
            baslik: "Gizle / Göster",
            tiklandi: () => {
                this.visible = !this.visible;
                this.sahne.anaGosterim.FikoYT.degisti.emit();
                // this.sahne.anaGosterim.ciz();
            }
        },
        {
            simgeYazi: "🖥",
            baslik: "Ekrana Sığdır",
            tiklandi: () => {
                this.sahne.ekranaSigdir(this.sahne);
            }
        },
        {
            simgeYazi: "🖊",
            baslik: "Düzenle",
            tiklandi: () => {
                this.sahne.anaGosterim.DialogFiko.ac({ bilesen: FikoEksenComponent, parametreler: { eksen: this }, $event: null, ayarlar: { baslik: 'FikoYT Eksen Ayarlar', simgeResim: './simgeler/xyz-1.webp' } });
            }
        },
        {
            simgeYazi: "📁",
            baslik: "Apt'den Oku",
            tiklandi: () => {
                this.aptden();
            }
        },
    ]
    /** */
    override solAracCubugu = [
        {
            baslik: "Düzenle",
            simge: "edit",
            tiklandi: () => {
                this.sahne.anaGosterim.DialogFiko.ac({ bilesen: FikoEksenComponent, parametreler: { eksen: this }, $event:null, ayarlar: { baslik: 'FikoYT Eksen Ayarlar', simgeResim: './simgeler/xyz-1.webp' } });
            }
        }
    ]
    /** */
    hizli3DMenu = [
        {
            simgeYazi: "👁‍🗨",
            baslik: "Gizle / Göster",
            tiklandi: () => {
                this.visible = !this.visible;
                this.sahne.anaGosterim.FikoYT.degisti.emit();
                // this.sahne.anaGosterim.ciz();
            }
        },
    ]
    hizliMenu3DBilgi?: string = "Konum Bilgisini İçerir";

    createPlane(name: string, size = 1, color = 0xaaaaaa): THREE.Mesh {
        const geometry = new THREE.PlaneGeometry(size, size);
        const material = new THREE.MeshBasicMaterial({
            color,
            opacity: 0.3,
            transparent: true,
            side: THREE.DoubleSide,
            depthTest: false,
        });
        const plane = new THREE.Mesh(geometry, material);
        plane.name = name;
        plane.userData.type = "Duzlem";
        return plane;
    }
    // ✅ Tam modüler createLabelFull
    createLabel({
        text,
        textColor = '#000000',
        backgroundColor,
        borderColor = '#000000',
        borderWidth = 0,
        borderRadius = 8,
        fontSize = 32,
        preferredFontSize = fontSize,
        minFontSize = 10,
        fontFamily = 'Arial',
        padding = 16,
        shadow = false,
        shadowOptions = { blur: 6, offsetX: 0, offsetY: 0, color: 'rgba(0,0,0,0.3)' },
        glow = true,
        glowOptions = { color: '#000', blur: 2 },
        scaleFactor = 0.01,
        wrapText = false,
        autoWrapIfNeeded = false,
        autoFitFontSize = false,
        autoGrowHeight = false,
        maxWidth = 512,
        maxHeight = 128,
        align = 'center',
        valign = 'middle',
        markdown = false,
    }: {
        text: string,
        textColor?: string,
        backgroundColor?: string,
        borderColor?: string,
        borderWidth?: number,
        borderRadius?: number,
        fontSize?: number,
        preferredFontSize?: number,
        minFontSize?: number,
        fontFamily?: string,
        padding?: number,
        shadow?: boolean,
        shadowOptions?: { blur: number, offsetX: number, offsetY: number, color: string },
        glow?: boolean,
        glowOptions?: { color: string, blur: number },
        scaleFactor?: number,
        wrapText?: boolean,
        autoWrapIfNeeded?: boolean,
        autoFitFontSize?: boolean,
        autoGrowHeight?: boolean,
        maxWidth?: number,
        maxHeight?: number,
        align?: 'left' | 'center' | 'right',
        valign?: 'top' | 'middle' | 'bottom',
        markdown?: boolean,
    }): THREE.Sprite {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d')!;

        if (markdown) text = text.replace(/\*([^*]+)\*/g, '$1').replace(/_([^_]+)_/g, '$1');

        let currentFontSize = preferredFontSize;
        let lines: string[] = [text];

        const measure = (fontSize: number) => {
            ctx.font = `${fontSize}px ${fontFamily}`;
            let w = ctx.measureText(text).width;
            let l = [text];
            if (wrapText || autoWrapIfNeeded) {
                const words = text.split(' ');
                let line = '';
                l = [];
                for (const word of words) {
                    const testLine = line + word + ' ';
                    const testWidth = ctx.measureText(testLine).width;
                    if (testWidth > maxWidth - padding * 2) {
                        l.push(line.trim());
                        line = word + ' ';
                    } else {
                        line = testLine;
                    }
                }
                if (line.trim()) l.push(line.trim());
                w = maxWidth;
            }
            return { width: w, height: fontSize * l.length, lines: l };
        };

        // autoFit loop
        while (autoFitFontSize && currentFontSize >= minFontSize) {
            const m = measure(currentFontSize);
            if (m.width + padding * 2 <= maxWidth && m.height + padding * 2 <= maxHeight) {
                lines = m.lines;
                break;
            }
            currentFontSize--;
        }

        if (!autoFitFontSize) {
            const m = measure(currentFontSize);
            lines = m.lines;
        }

        // 🔧 FIX: Math.max spread overflow için loop kullan (tutarlılık için)
        const lineWidths = lines.map(line => ctx.measureText(line).width);
        let textWidth = lineWidths[0] || 0;
        for (let i = 1; i < lineWidths.length; i++) {
            if (lineWidths[i] > textWidth) textWidth = lineWidths[i];
        }
        const textHeight = currentFontSize * lines.length;
        const width = textWidth + padding * 2;
        const height = autoGrowHeight ? textHeight + padding * 2 : Math.min(textHeight + padding * 2, maxHeight);

        canvas.width = width;
        canvas.height = height;
        ctx.font = `${currentFontSize}px ${fontFamily}`;
        ctx.textAlign = align;
        ctx.textBaseline = 'middle';

        if (shadow) {
            ctx.shadowColor = shadowOptions.color;
            ctx.shadowBlur = shadowOptions.blur;
            ctx.shadowOffsetX = shadowOptions.offsetX;
            ctx.shadowOffsetY = shadowOptions.offsetY;
        }

        if (backgroundColor || borderWidth > 0) {
            const r = borderRadius;
            ctx.beginPath();
            ctx.moveTo(r, 0);
            ctx.lineTo(width - r, 0);
            ctx.quadraticCurveTo(width, 0, width, r);
            ctx.lineTo(width, height - r);
            ctx.quadraticCurveTo(width, height, width - r, height);
            ctx.lineTo(r, height);
            ctx.quadraticCurveTo(0, height, 0, height - r);
            ctx.lineTo(0, r);
            ctx.quadraticCurveTo(0, 0, r, 0);
            ctx.closePath();

            if (backgroundColor) {
                ctx.fillStyle = backgroundColor;
                ctx.fill();
            }

            if (borderWidth > 0) {
                ctx.lineWidth = borderWidth;
                ctx.strokeStyle = borderColor;
                ctx.stroke();
            }
        }

        ctx.shadowColor = 'transparent';

        if (glow) {
            ctx.shadowColor = glowOptions.color;
            ctx.shadowBlur = glowOptions.blur;
        }

        ctx.fillStyle = textColor;
        lines.forEach((line, i) => {
            let x = align === 'left' ? padding : align === 'right' ? width - padding : width / 2;
            let y = padding + currentFontSize / 2 + i * currentFontSize;
            if (valign === 'top') y = padding + currentFontSize / 2 + i * currentFontSize;
            else if (valign === 'bottom') y = height - (lines.length - i - 0.5) * currentFontSize - padding;
            ctx.fillText(line, x, y);
        });

        const texture = new THREE.CanvasTexture(canvas);
        texture.needsUpdate = true;

        const material = new THREE.SpriteMaterial({
            map: texture,
            depthTest: false,
            depthWrite: false,
            transparent: true,
            fog: false,
        });

        const sprite = new THREE.Sprite(material);
        sprite.scale.set(width * scaleFactor, height * scaleFactor, 1);
        return sprite;
    }

    createCircleTexture(size = 64) {
        const canvas = document.createElement('canvas');
        canvas.width = canvas.height = size;

        const ctx = canvas.getContext('2d')!;
        const center = size / 2;
        const radius = center;

        ctx.clearRect(0, 0, size, size);

        // Daire çiz
        ctx.beginPath();
        ctx.arc(center, center, radius, 0, 2 * Math.PI, false);
        ctx.fillStyle = '#ffffff'; // beyaz, çünkü color PointsMaterial'den gelecek
        ctx.fill();

        const texture = new THREE.CanvasTexture(canvas);
        texture.needsUpdate = true;
        return texture;
    }


    constructor(public override sahne?: FikoSahne, name?: string,
        public _merkez: THREE.Vector3 = new THREE.Vector3(0, 0, 0),
        public _xYon: THREE.Vector3 = new THREE.Vector3(1, 0, 0),
        public _yYon: THREE.Vector3 = new THREE.Vector3(0, 1, 0),
        public _zYon: THREE.Vector3 = new THREE.Vector3(0, 0, 1)
    ) {
        super(sahne, name);
        this.renderOrder = 999999;
        this.frustumCulled = false;
        this.add(new FikoArrowYardimci(this.sahne, new FikoVektor3D(1, 0, 0), new FikoVektor3D(0, 0, 0), 3, this.renkler.x));
        this.add(new FikoArrowYardimci(this.sahne, new FikoVektor3D(0, 1, 0), new FikoVektor3D(0, 0, 0), 3, this.renkler.y));
        this.add(new FikoArrowYardimci(this.sahne, new FikoVektor3D(0, 0, 1), new FikoVektor3D(0, 0, 0), 3, this.renkler.z));

        // this.add(new THREE.Mesh(new THREE.SphereGeometry(0.05, 6, 6), new THREE.MeshBasicMaterial({ color: this.renkler?.merkez, depthTest: false })))

        // Merkez noktası - depthWrite: false olmalı, diğerleriyle tutarlı
        this.add(new THREE.Points(new THREE.BufferGeometry().setFromPoints([new FikoVektor3D(0, 0, 0)]), new THREE.PointsMaterial({ color: this.renkler?.merkez, map: this.createCircleTexture(), size: 7, depthTest: false, transparent: true, depthWrite: false })));
        (this.children[3] as THREE.Points).renderOrder = 999999;
        (this.children[3] as THREE.Points).frustumCulled = false;

        // 🏷️ XYZ Etiketleri - her zaman en üstte render
        // FikoCizimYalin pattern: depthTest=false, depthWrite=false, transparent=true
        // renderOrder oklardan 1 fazla olmalı ki etiketler okların üstünde çizilsin

        const labelX = this.createLabel({ text: 'X', textColor: '#00a3ff', fontSize: 36, scaleFactor: 0.008, glow: true, glowOptions: { color: '#00a3ff', blur: 2 } });
        labelX.position.set(3.3, 0, 0);
        labelX.renderOrder = 1000000; // Oklar 999999, etiketler 1000000
        labelX.frustumCulled = false;
        labelX.center.set(0.5, 0.5);
        this.add(labelX);

        const labelY = this.createLabel({ text: 'Y', textColor: '#05ab44', fontSize: 36, scaleFactor: 0.008, glow: true, glowOptions: { color: '#05ab44', blur: 2 } });
        labelY.position.set(0, 3.3, 0);
        labelY.renderOrder = 1000000;
        labelY.frustumCulled = false;
        labelY.center.set(0.5, 0.5);
        this.add(labelY);

        const labelZ = this.createLabel({ text: 'Z', textColor: '#ffff00', fontSize: 36, scaleFactor: 0.008, glow: true, glowOptions: { color: '#ffff00', blur: 2 } });
        labelZ.position.set(0, 0, 3.3);
        labelZ.renderOrder = 1000000;
        labelZ.frustumCulled = false;
        labelZ.center.set(0.5, 0.5);
        this.add(labelZ);

        this.children[0].name = "X Yönü"
        this.children[1].name = "Y Yönü"
        this.children[2].name = "Z Yönü"

        this.children[3].name = "Merkez"
        this.children[4].name = "X Etiketi"
        this.children[5].name = "Y Etiketi"
        this.children[6].name = "Z Etiketi"

        this.children[0].userData.fikoType = "Yön"
        this.children[1].userData.fikoType = "Yön"
        this.children[2].userData.fikoType = "Yön"

        this.children[3].userData.fikoType = "Merkez"
        this.children[4].userData.fikoType = "Etiket"
        this.children[5].userData.fikoType = "Etiket"
        this.children[6].userData.fikoType = "Etiket"

        this.name = name;

        this.userData.FikoArayuz.agactaGorunur = true;
        this.userData.FikoArayuz.listeGoster = false;
        this.userData.FikoArayuz.simge = "./simgeler/xyz-1.webp";

        this.position.copy(this._merkez);
        this.setRotationFromMatrix(new THREE.Matrix4().makeBasis(this._xYon, this._yYon, this._zYon).setPosition(this._merkez))

        this.userData.xYon = this._xYon;
        this.userData.yYon = this._yYon;
        this.userData.zYon = this._zYon;
        this.userData.merkez = this._merkez;

        // Not: X, Y, Z okları, merkez noktası ve XYZ etiketleri - düzlemler kaldırıldı


        // this.traverse((subObj) => {
        //     subObj.raycast = (a, r) => {
        //         r.push({
        //             object: this,
        //             distance: 0,
        //             point: null,
        //             face: null,
        //             faceIndex: null,
        //             index: null,
        //             instanceId: this.id,
        //         });
        //     }
        // });

        // 🔥 FIX: Her zaman üstte görünmesi için maksimum renderOrder ve depth ayarları
        this.frustumCulled = false;
        // Yüksek renderOrder kullan (ama Number.MAX_SAFE_INTEGER değil - render sorunları yaratabilir)
        const EKSEN_RENDER_ORDER = 999999;
        this.renderOrder = EKSEN_RENDER_ORDER;

        // 🔥 FIX: Tüm alt objelere de aynı ayarları ata
        this.layers.enableAll(); // Tüm kamera layer'larında görünür

        this.traverse((child: THREE.Object3D) => {
            child.frustumCulled = false;
            // Etiketler (Sprite) için renderOrder korunmalı (1000000)
            // Diğer objeler için EKSEN_RENDER_ORDER (999999) kullan
            const isSprite = (child as THREE.Sprite).isSprite;
            if (!isSprite && child.renderOrder < EKSEN_RENDER_ORDER) {
                child.renderOrder = EKSEN_RENDER_ORDER;
            }
            child.layers.enableAll(); // Tüm kamera layer'larında görünür

            // Material varsa depthTest: false yap
            const mesh = child as THREE.Mesh;
            if (mesh.material) {
                if (Array.isArray(mesh.material)) {
                    mesh.material.forEach((mat: THREE.Material) => {
                        mat.depthTest = false;
                        mat.depthWrite = false;
                        mat.transparent = true;
                    });
                } else {
                    (mesh.material as THREE.Material).depthTest = false;
                    (mesh.material as THREE.Material).depthWrite = false;
                    (mesh.material as THREE.Material).transparent = true;
                }
            }

            // Line material kontrolü
            const line = child as THREE.Line;
            if (line.isLine && line.material) {
                (line.material as THREE.Material).depthTest = false;
                (line.material as THREE.Material).depthWrite = false;
                (line.material as THREE.Material).transparent = true;
            }

            // Points material kontrolü
            const points = child as THREE.Points;
            if (points.isPoints && points.material) {
                (points.material as THREE.Material).depthTest = false;
                (points.material as THREE.Material).depthWrite = false;
                (points.material as THREE.Material).transparent = true;
            }

            // Sprite material kontrolü
            const sprite = child as THREE.Sprite;
            if (sprite.isSprite && sprite.material) {
                sprite.material.depthTest = false;
                sprite.material.depthWrite = false;
            }
        });

        if (sahne)
            this.hazirla(sahne);
    }

    get merkez(): FikoVektor3D {
        return this.userData.merkez;
    }

    get xYon(): any {
        return this.userData.xYon;
    }

    get yYon(): FikoVektor3D {
        return this.userData.yYon;
    }

    get zYon(): FikoVektor3D {
        return this.userData.zYon;
    }

    initOlaylar(anaGosterim: FikoThreeJsComponent) {
        // anaGosterim?.sahne?.aktifKontrol?.addEventListener("change", (val: any) => {
        //     // RS+: Sabit Boyut
        //     if (this.sabitBoyut == true) {
        //         const factor = (anaGosterim.anaKamera.top - anaGosterim.anaKamera.bottom) / anaGosterim.anaKamera.zoom;
        //         this.scale.set(1, 1, 1).multiplyScalar(factor * 1 / 10);
        //     }
        // });
        // RS+: Odaktakiler Değişti
        // anaGosterim.olayOdaktakilerGuncellendi.subscribe((odaktakiler: Intersection[]) => {
        //     // RS+: Odak Kontrol
        //     let odaktaki = odaktakiler[0]?.object
        //     if (odaktaki?.parent?.parent == this) {
        //         if (anaGosterim.secimFilitresi.indexOf("FikoEksen") > -1) {
        //             this.odakta();
        //         } else {
        //             this.odaktaDegil();
        //             if (odaktaki.parent.type == "Yön" || odaktaki.type == "Merkez") {
        //                 (odaktaki.parent as any).setColor(anaGosterim.GenelAyarlar.renkler.odak)
        //             }
        //         }
        //     } else {
        //         this.odaktaDegil();
        //         // RS+: Seçim Kontrol
        //         if (anaGosterim.secilenler.indexOf(this) < 0) {
        //             this.seciliDegil();
        //         } else {
        //             this.secildi();
        //         }
        //         anaGosterim.secilenler.forEach((secili: any) => {
        //             if (this.children.indexOf(secili.parent) > -1) {
        //                 (secili?.parent as any)?.setColor(anaGosterim.GenelAyarlar.renkler.secim)
        //             }
        //         })
        //     }
        // })
    }

    odakta() {
        this.odakAktif = true;
        if (this.secili) return;
        (this.children[0] as FikoArrowYardimci).setColor(0xFF7F00);
        (this.children[1] as FikoArrowYardimci).setColor(0xFF7F00);
        (this.children[2] as FikoArrowYardimci).setColor(0xFF7F00);
        //@ts-ignore
        (this.children[3] as THREE.Mesh).material.color.set(0xFF7F00);
        // this.sahne.anaGosterim.ciz();
    }

    odaktaDegil() {
        this.odakAktif = false;

        if (this.secili) return;
        (this.children[0] as FikoArrowYardimci)?.setColor(this.renkler.x);
        (this.children[1] as FikoArrowYardimci)?.setColor(this.renkler.y);
        (this.children[2] as FikoArrowYardimci)?.setColor(this.renkler.z);
        //@ts-ignore
        (this.children[3] as THREE.Mesh).material.color.set(this.renkler.merkez);
        // this.sahne.anaGosterim.ciz();
    }

    secildi() {
        (this.children[0] as FikoArrowYardimci).setColor(0xff0000);
        (this.children[1] as FikoArrowYardimci).setColor(0xff0000);
        (this.children[2] as FikoArrowYardimci).setColor(0xff0000);
        //@ts-ignore
        (this.children[3] as THREE.Mesh).material.color.set(0xff0000);
        this.secili = true;
        // this.sahne.anaGosterim.ciz();
    }

    secilmedi() {
        (this.children[0] as FikoArrowYardimci)?.setColor(this.renkler.x);
        (this.children[1] as FikoArrowYardimci)?.setColor(this.renkler.y);
        (this.children[2] as FikoArrowYardimci)?.setColor(this.renkler.z);
        //@ts-ignore
        (this.children[3] as THREE.Mesh).material.color.set(this.renkler.merkez);
        this.secili = false;
        // this.odaktaDegil();
        // this.sahne.anaGosterim.ciz();
    }

    override hazirla(sahne?: FikoSahne) {
        super.hazirla(sahne);
        const factor = (sahne?.anaGosterim.aktifKamera?.top - sahne?.anaGosterim.aktifKamera?.bottom) / sahne?.anaGosterim.aktifKamera?.zoom;
        this.scale.set(1, 1, 1).multiplyScalar(factor * 1 / 20);
        sahne?.updateMatrixWorld();

        // 🚀 PERFORMANS: Handler referansını tut - dispose için gerekli
        this._kontrolDegistiHandler = (event: any) => {
            const factor = (sahne?.anaGosterim.aktifKamera?.top - sahne?.anaGosterim.aktifKamera?.bottom) / sahne?.anaGosterim.aktifKamera?.zoom;
            this.scale.set(1, 1, 1).multiplyScalar(factor * 1 / 20);
            // 🚀 PERFORMANS: updateMatrixWorld kaldırıldı - render döngüsünde otomatik güncellenir
            this.matrixWorldNeedsUpdate = true;
        };
        sahne.anaGosterim.aktifKontrol?.addEventListener("change", this._kontrolDegistiHandler);


        // this.add(new Fiko3DYazi(this.sahne, "Fiko\nYT",1,0xffffff))

        // let marker = new Fiko3DIsaretleyici(this.sahne,"A");
        // marker.position.set(0, 0, 300)
        // this.sahne.ekle(marker)
    }

    override raycast(raycaster: Raycaster, intersects: Intersection[]): void {
        let kesisenler = raycaster.intersectObjects(this.children, true);

        if (kesisenler.length > 0) {
            intersects.push({
                object: this,
                distance: kesisenler[0].distance,
                point: kesisenler[0].point,
                face: null,
                faceIndex: null,
                index: null,
                instanceId: this.id,
                //@ts-ignore
                yon: { x: this.xYon, y: this.yYon, z: this.zYon },
                altObje: kesisenler[0].object,
                grup: this,
                tiklandi: () => this.tiklandi(),
                ciftTiklandi: () => this.ciftTiklandi(),
                odakta: () => this.odakta(),
                odaktaDegil: () => this.odaktaDegil(),
                enUstte: true,
                secilebilir: true,
            });

        } else {
            return;
        }
    }

    // raycast1(raycaster: THREE.Raycaster, intersects: THREE.Intersection[]): void {
    //     let kesisenler = raycaster.intersectObjects(this.children, true);

    //     kesisenler.forEach((elm: any) => {
    //         elm.grup = this;

    //     })

    //     intersects.push(...kesisenler);

    //     // if (kesisenler.length > 0) {
    //     //     intersects.push({
    //     //         object: this,
    //     //         // distance: 0,
    //     //         point: null,
    //     //         face: null,
    //     //         faceIndex: null,
    //     //         index: null,
    //     //         instanceId: this.id,
    //     //         //@ts-ignore
    //     //         // yon: { x: this.xYon, y: this.yYon, z: this.zYon },
    //     //         altObje: kesisenler[0].object,
    //     //     });

    //     // } else {
    //     //     return;
    //     // }
    // }


    tiklandi() {
        // if (this.secili) {
        //     this.secilmedi();
        // } else {
        //     this.secildi();
        // }
        // console.log("tıklandı");
    }

    ciftTiklandi($event?) {
         this.sahne.anaGosterim.DialogFiko.ac({ bilesen: FikoEksenComponent, parametreler: { eksen: this }, $event: $event, ayarlar: { baslik: 'FikoYT Eksen Ayarlar', simgeResim: './simgeler/xyz.webp' } });
    }


    aptden() {
        // var _this = this;
        // let input = document.createElement("input");
        // input.type = "file";
        // input.accept = ".FikoApt, .AptSource, .apt"
        // input.onchange = ($event: any) => {
        //     if ($event.target.files && $event.target.files[0]) {
        //         const dosya: File = $event.target.files[0]

        //         // if (dosya.type == "application/vnd.ms-pki.stl")
        //         // _this.ekleApt(dosya);

        //         _this.loader.load(URL.createObjectURL(dosya),

        //             (data: any) => {
        //                 let fikoApt = new FikoApt(_this.sahne);
        //                 // fikoApt.strApt = data;
        //                 fikoApt.arrayApt = data.split("\n");
        //                 fikoApt.parcala();
        //                 // fikoApt.agactaGorunur = true;

        //                 _this.position.copy(fikoApt.eksenKoord.o);
        //                 _this.setRotationFromMatrix(new THREE.Matrix4().makeBasis(fikoApt.eksenKoord.x, fikoApt.eksenKoord.y, fikoApt.eksenKoord.z).setPosition(fikoApt.eksenKoord.o))

        //                 _this.userData.xYon = fikoApt.eksenKoord.x;
        //                 _this.userData.yYon = fikoApt.eksenKoord.y;
        //                 _this.userData.zYon = fikoApt.eksenKoord.z;
        //                 _this.userData.merkez = fikoApt.eksenKoord.o;

        //                 fikoApt = undefined;
        //                 // _this.add(fikoApt);
        //                 _this.sahne.anaGosterim.FikoYT.degisti.emit();
        //                 _this.sahne.anaGosterim.ciz();

        //             },
        //             function (xhr) {
        //                 // console.log((xhr.loaded / xhr.total * 100) + '% loaded');
        //             },
        //             function (err) {
        //                 // console.error('An error happened');
        //             }
        //         );

        //     }
        // }
        // input.click();
    }

    konumAyarlaJson(json: any) {
        this.position.copy(new THREE.Vector3().fromArray(json.merkez));
        this.setRotationFromMatrix(new THREE.Matrix4().makeBasis(new THREE.Vector3().fromArray(json.x), new THREE.Vector3().fromArray(json.y), new THREE.Vector3().fromArray(json.z)).setPosition(new THREE.Vector3().fromArray(json.merkez)));
        this.userData.xYon = new THREE.Vector3().fromArray(json.x);
        this.userData.yYon = new THREE.Vector3().fromArray(json.y);
        this.userData.zYon = new THREE.Vector3().fromArray(json.z);
        this.userData.merkez = new THREE.Vector3().fromArray(json.merkez);

        this.sahne.anaGosterim.FikoYT.degisti.emit();
        // this.sahne.anaGosterim.ciz();
    }

    override toJSON(meta?: { geometries: any; materials: any; textures: any; images: any }): any {
        const _rslt: any = {
            type: this.type,
            isim: this.name,
            matrix: this.matrix.toArray(),
            xYon: this.xYon,
            yYon: this.yYon,
            zYon: this.zYon,
            merkez: this.merkez,
            visible: this.visible,
            userData: this._serializeUserData(),
        } // super.toJSON(meta);

        return _rslt
    }

    static fromJson(sahne?: FikoSahne, parent?: any, json?: any) {
        const merkez = new FikoVektor3D(json.merkez.x, json.merkez.y, json.merkez.z);
        const xYon = new FikoVektor3D(json.xYon.x, json.xYon.y, json.xYon.z);
        const yYon = new FikoVektor3D(json.yYon.x, json.yYon.y, json.yYon.z);
        const zYon = new FikoVektor3D(json.zYon.x, json.zYon.y, json.zYon.z);

        const _rslt = new FikoEksen(sahne, json.isim, merkez, xYon, yYon, zYon);

        _rslt.parent = parent;

        // Görünürlük durumu
        if (json.visible !== undefined) {
            _rslt.visible = json.visible;
        }

        // userData geri yukle
        if (json.userData) {
            _rslt._restoreUserData(json.userData);
        }

        return _rslt;
        /**
        delete json.children;
        const mtrx = json.matrix;
        delete json.matrix;
     
     
        const merkez = new FikoVektor3D(json.userData.merkez.x, json.userData.merkez.y, json.userData.merkez.z);
        const xYon = new FikoVektor3D(json.userData.xYon.x, json.userData.xYon.y, json.userData.xYon.z);
        const yYon = new FikoVektor3D(json.userData.yYon.x, json.userData.yYon.y, json.userData.yYon.z);
        const zYon = new FikoVektor3D(json.userData.zYon.x, json.userData.zYon.y, json.userData.zYon.z);
     
        const _rslt = new FikoEksen(sahne, json.name, merkez, xYon, yYon, zYon);
     
        // _rslt.matrix.fromArray(mtrx);
        // _rslt.layers = new THREE.Layers();
        // _rslt.layers.set(json.layers);
     
        _rslt.parent = parent;
     
        // (sahne as SahneFikoAptSimilasyon).cizimler.eksenler.add(_rslt);
        // for (let i = 0; i < _rslt.children.length; i++) {
        //     let element = _rslt.children[i];
        //     element = mdl.jsondan(element);
        // }
        return _rslt;
        */
    }

    /** 🚀 PERFORMANS: Memory leak önlemek için dispose metodu */
    dispose(): void {
        // Event listener'ı kaldır
        if (this._kontrolDegistiHandler && this.sahne?.anaGosterim?.aktifKontrol) {
            this.sahne.anaGosterim.aktifKontrol.removeEventListener("change", this._kontrolDegistiHandler);
            this._kontrolDegistiHandler = null;
        }

        // Children'ları temizle
        for (let i = this.children.length - 1; i >= 0; i--) {
            const child = this.children[i];
            if ((child as any).dispose) {
                (child as any).dispose();
            }
            if ((child as THREE.Mesh).geometry) {
                (child as THREE.Mesh).geometry.dispose();
            }
            if ((child as THREE.Mesh).material) {
                const mat = (child as THREE.Mesh).material;
                if (Array.isArray(mat)) {
                    mat.forEach(m => m.dispose());
                } else {
                    (mat as THREE.Material).dispose();
                }
            }
        }
    }
}